import { useState } from 'react'
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  VStack,
  useColorMode,
  useToast,
} from '@chakra-ui/react'

interface EnterpriseContactModalProps {
  isOpen: boolean
  onClose: () => void
}

export function EnterpriseContactModal({ isOpen, onClose }: EnterpriseContactModalProps) {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'
  const toast = useToast()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [company, setCompany] = useState('')
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!name || !email || !message) {
      toast({
        title: 'Please fill in all required fields',
        status: 'error',
        duration: 3000,
      })
      return
    }

    setIsSubmitting(true)

    // For now, open mailto with pre-filled content
    const subject = encodeURIComponent(`Enterprise inquiry from ${company || name}`)
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nCompany: ${company || 'N/A'}\n\nMessage:\n${message}`
    )
    window.location.href = `mailto:enterprise@myrkup.com?subject=${subject}&body=${body}`

    setIsSubmitting(false)
    toast({
      title: 'Opening email client...',
      description: "If it doesn't open, email us at enterprise@myrkup.com",
      status: 'success',
      duration: 5000,
    })
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg={isDark ? 'stone.800' : 'white'}>
        <ModalHeader>Contact us</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Company</FormLabel>
              <Input
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="Your company"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Message</FormLabel>
              <Textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tell us about your needs..."
                rows={4}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="solid"
            onClick={handleSubmit}
            isLoading={isSubmitting}
          >
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
